import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';

class PrivateRoute extends PureComponent {
  _renderComponent = AuthtenticatedComponent => props => (
    <AuthtenticatedComponent {...props} />
  );

  _renderAuthComponent = ({
    composedComponent: AuthtenticatedComponent,
    ...rest
  }) => (
    <Route {...rest} render={this._renderComponent(AuthtenticatedComponent)} />
  );

  render() {
    return <div>{this._renderAuthComponent(this.props)}</div>;
  }
}

PrivateRoute.propTypes = {
  composedComponent: PropTypes.any,
};

export default PrivateRoute;
